import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import {Text} from "../";

export const Texts = ({ topics }) => {
  //console.log(topics);
  return (
    <Container fluid className="module-texts">
      <Row style={{padding: '0 2vh'}}>
        {topics &&
          topics.length &&
          topics.map((topic, i) => {
            return (
              <Col xs={12} sm={12} md={6} key={"topic" + i} className={'text-tile'}>
                <Text topic={topic} />
              </Col>
            );
          })}
      </Row>
    </Container>
  );
};
